<template>
    <a-input-search v-model="value" class="search-bar-input" placeholder="搜索课程~"
                    @search="onSearch"
                    size="large">
        <a-button class="search-bar-button" slot="enterButton" size="large"
                  :style="{background: type?'transparent':'#00B278',lineHeight: '100%'}">
          <img src="@assets/img/index/search-icon.png" alt="">
        </a-button>
    </a-input-search>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "SearchBar",
        props:{
          type:{
            type:Boolean,
            default:false
          }
        },
        data() {
            return {
                value: ''
            }
        },
        created() {
            this.value = this.searchKeyword;
        },
        methods: {
            //搜索框
            onSearch(value) {
                this.$store.commit("changeSearchKeyword", {searchKeyword: value});
                const query = {
                    keyword: value,
                };
                if (this.$route.name === 'search') {
                    query.type = this.$route.query.type;
                    query.subject = this.$route.query.subject
                }
                this.$router.replace({
                    path: "/other/search",
                    query
                }).catch(err => {
                    err
                })
            },
        },
        computed: {
            ...mapState({
                searchKeyword: 'searchKeyword'
            })
        },
        watch: {
            searchKeyword() {
                this.value = this.searchKeyword;
            }
        }
    }
</script>

<style scoped lang="less">
    /deep/.ant-input-group-addon{
      background-color:transparent;
    }
    .ant-input-group-wrapper {
        width: 300px;
    }

    .search-bar-input {
        /deep/ .ant-input-lg {
            height: 38px;
        }
    }

    .search-bar-button {
        height: 38px;
        margin-left: -2px;


    }

    /deep/ .ant-btn > .anticon + span, .ant-btn > span + .anticon {
        margin-left: 5px;
    }

    /deep/ .ant-select-selection__placeholder {
        color: black;
        font-size: 14px;
    }

    /deep/ .ant-select-selection {
        border: none;
    }

    /deep/ .ant-select-selection > * {
        color: black;
    }

    /deep/ .ant-input-lg {
        border-radius: 20px;
    }

    /deep/ .ant-input-search-button {
        border-radius: 20px;
    }
</style>
